module.exports = __webpack_public_path__ + "img/4-2.45f39688.jpg";